import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCreditCard,
  faArrowTrendUp,
  faBell,
  faCircleCheck,
  faCircleExclamation,
  faFolder,
  faGlobe,
  faEdit,
  faQuestionCircle,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../components/Other/DashboardHeader";
import { Link, useOutletContext } from "react-router-dom";
import {
  createConnectAccountApi,
  deleteAccount,
  getSettings,
} from "../api/user";
import Loader from "../components/Loader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import ConnectAccount from "./stripe-payment/bank-account/connect-account";
import Select from "react-select";
import { event } from "../utils/event";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DeleteAccountModal from "../components/Modals/deleteAccountModal";
import { async } from "q";
import { SUBSCRIPTION_ENABLED } from "../utils/utils";

const Settings = () => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({
    value: "US",
    label: "USA",
  });
  const [connectOpen, setConnectOpen] = useState(null);
  const [status, setStatus] = useState({});
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [openAcountModal, setOpenAcountModal] = useState(false);
  const navigate = useNavigate();

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };
  const [stripeKey, setStripeKey] = useState("");

  const fetchSetting = async () => {
    try {
      const response = await getSettings();
      if (response?.data?.data) {
        setisDataFeteched(true);
        setStripeKey(response.data.data.pk_key);
        setSettings(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (!isDataFeteched) fetchSetting();
  }, []);

  const openLinkInNewTab = (url) => {
    const newTab = window.open();
    newTab.opener = null;
    newTab.location.href = url;
  };
  const flutterMobile = localStorage.getItem("isFlutterInAppWebViewReady");

  const redirectToAboutUs = () => {
    if (!flutterMobile) {
      openLinkInNewTab(settings.about_us);
    } else {
      event("about_us", settings.about_us);
    }
  };

  const handleDeleteCancel = () => {
    setOpenAcountModal(false);
  };

  const handleDeleteAcount = async () => {
    try {
      const login_type = localStorage.getItem("google_login");
      if (login_type == "1") {
        event("sendEventForGoogleLogout");
      }
      const response = await deleteAccount();
      if (response) {
        setOpenAcountModal(false);
        toast.success(response.data.message);
        localStorage.clear();
        window.location.reload();
        navigate("/");
      } else {
        setOpenAcountModal(false);
      }
    } catch (error) {
      setOpenAcountModal(false);
      toast.error(error.response.data.message);
      console.error("Error:", error);
    }
  };

  const redirectToHelp = () => {
    if (!flutterMobile) {
      openLinkInNewTab(settings.help);
    } else {
      event("help", settings.help);
    }
  };

  const redirectToTc = () => {
    if (!flutterMobile) {
      openLinkInNewTab(settings.terms_conditions);
    } else {
      event("terms_conditions", settings.terms_conditions);
    }
  };

  const redirectToPp = () => {
    if (!flutterMobile) {
      openLinkInNewTab(settings.privacy_policy);
    } else {
      event("privacy_policy", settings.privacy_policy);
    }
  };

  const accountDelete = async () => {
    setOpenAcountModal(true);
  };

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all")
      .then((response) => response.json())
      .then((data) => {
        const transformedCountries = data.map((country) => ({
          value: country.cca2,
          label: country.name.common,
        }));
        setCountryOptions(transformedCountries);
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
      });
  }, []);

  const handleAddAccountDetails = () => {
    setConnectOpen(true);
  };

  useEffect(() => {
    handleAddAccount();
  }, []);

  const handleAddAccount = async () => {
    const res = await createConnectAccountApi(selectedCountry?.value);
    setStatus(res.data);
    if (connectOpen && res?.status === 200) {
      if (res?.data?.onboarding_status == "completed") {
      } else {
        window.open(
          res?.data?.new_onboarding_link,
          "_blank",
          "noopener,noreferrer"
        );
      }
      setConnectOpen(false);
    }
  };
  const handleCancelAccount = () => {
    setConnectOpen(false);
  };

  const handleUpdateAccount = () => {
    window.open(status?.new_onboarding_link, "_blank", "noopener,noreferrer");
  };

  const [sidebarToggle] = useOutletContext();

  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const user_data = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title="Settings" />
      <PageContainer>
        {loading ? (
          <Loader dark />
        ) : (
          <>
            {!isMobileView && (
              <div className="hidden md:block md:mt-4 mt-0 p-8 rounded-2xl border bg-white border-white-500 max-w-[60rem] mx-auto mb-3">
                <div className="hidden md:block space-y-8 w-[800px] px-3">
                  <div className="flex items-center mt-10">
                    <img
                      src={user_data?.image}
                      alt="logo"
                      className="object-cover w-16 h-16 rounded-full"
                    />
                    <div className="ml-4">
                      <p>{user_data && user_data?.user_name ? "@" + user_data?.user_name :  user_data?.full_name}</p>
                      <p>{user_data?.title}</p>
                    </div>
                  </div>
                  <h1 className="text-2xl font-bold">Settings</h1>
                  <div className="flex items-center justify-between cursor-pointer">
                    <div className="flex items-center space-x-2 ">
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faGlobe}
                          style={{ color: "green" }}
                        />
                      </div>
                      <p>Language</p>
                    </div>

                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <Link
                    to="/edit-profile"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    {" "}
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faEdit}
                        style={{ color: "green" }}
                      />
                      <p>Edit Profile</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>

                  <Link
                    to="/change-password"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    {" "}
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>Reset Password</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>
                  <Link
                    to="/saved-post"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    {" "}
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faFolder}
                        style={{ color: "green" }}
                      />
                      <p>Saved Folders</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>
                  {SUBSCRIPTION_ENABLED ? (
                    <>
                      <Link
                        to={`/payment`}
                        className="flex items-center justify-between cursor-pointer"
                      >
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faCreditCard}
                            style={{ color: "green" }}
                          />
                          <p>Payment</p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ color: "green" }}
                          />
                        </div>
                      </Link>

                      <div
                        className="flex items-center justify-between cursor-pointer"
                        onClick={handleAddAccountDetails}
                      >
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faCreditCard}
                            style={{ color: "green" }}
                          />
                          <p>Add Bank Account</p>
                          <span
                            className={`text-${
                              status?.onboarding_status === "completed"
                                ? "primaryColor"
                                : "red"
                            }`}
                          >
                            {status?.onboarding_status === "completed"
                              ? "(Active)"
                              : "(Inactive)"}
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ color: "green" }}
                          />
                        </div>
                      </div>

                      <div
                        className="flex items-center justify-between cursor-pointer"
                        onClick={() => {
                          navigate(`/paid-content/${user_data?.id}`);
                        }}
                      >
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            style={{ color: "green" }}
                          />
                          <p>Paid Content</p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ color: "green" }}
                          />
                        </div>
                      </div>
                    </>
                  ) : null}

                  <Link
                    to="/notifications"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faBell}
                        style={{ color: "green" }}
                      />
                      <p>Notifications</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={accountDelete}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>Delete Account</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={redirectToAboutUs}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>About Application</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={redirectToTc}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>Terms & Conditions</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={redirectToPp}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>Privacy Policy</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={redirectToHelp}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        style={{ color: "green" }}
                      />
                      <p>Help</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isMobileView && (
              <div className="px-2 py-4 rounded-2xl border bg-[#FBFCFC] border-white-500 max-w-[60rem] h-auto mx-auto mb-20">
                <div className="overflow-y-auto space-y-8 px-3">
                  <div className="flex items-center mt-10">
                    <img
                      src={user_data.image}
                      alt="logo"
                      className="object-cover w-16 h-16 rounded-full"
                    />
                    <div className="ml-4">
                      <p>{user_data.full_name}</p>
                      <p>{user_data.title}</p>
                    </div>
                  </div>
                  <h1 className="text-2xl font-bold">Settings</h1>
                  <div className="flex justify-between cursor-pointer">
                    <div className="w-full flex  items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faGlobe}
                        style={{ color: "green" }}
                      />
                      <p>Language</p>
                    </div>
                    <div className="flex items-center">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <Link
                    to="/edit-profile"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    {" "}
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faEdit}
                        style={{ color: "green" }}
                      />
                      <p>Edit Profile</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>

                  <Link
                    to="/change-password"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    {" "}
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>Reset Password</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>
                  {SUBSCRIPTION_ENABLED ? (
                    <>
                      <Link
                        to={`/payment`}
                        className="flex items-center justify-between cursor-pointer"
                      >
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faCreditCard}
                            style={{ color: "green" }}
                          />
                          <p>Payment</p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ color: "green" }}
                          />
                        </div>
                      </Link>

                      <div
                        className="flex items-center justify-between cursor-pointer"
                        onClick={handleAddAccountDetails}
                      >
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faCreditCard}
                            style={{ color: "green" }}
                          />
                          <p>Add Bank Account</p>
                          <span
                            className={`text-${
                              status?.onboarding_status === "completed"
                                ? "primaryColor"
                                : "red"
                            }`}
                          >
                            {status?.onboarding_status === "completed"
                              ? "(Active)"
                              : "(Inactive)"}
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ color: "green" }}
                          />
                        </div>
                      </div>

                      <div
                        className="flex justify-between cursor-pointer"
                        onClick={() => {
                          navigate(`/paid-content/${user_data?.id}`);
                        }}
                      >
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faCircleExclamation}
                            style={{ color: "green" }}
                          />
                          <p>Paid Content</p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            style={{ color: "green" }}
                          />
                        </div>
                      </div>
                    </>
                  ) : null}

                  {/* <div
                    className="flex items-center justify-between cursor-pointer"
                  // onClick={redirectToAboutUs}
                  > */}
                  {/* <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowTrendUp}
                        style={{ color: "green" }}
                      />
                      <p>Analytics</p>
                    </div> */}
                  {/* <Link to={""}>
                      <div className="flex items-center space-x-2">
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          style={{ color: "green" }}
                        />
                      </div>
                    </Link> */}
                  {/* </div> */}
                  <Link
                    to={"/saved-post"}
                    className="flex items-center justify-between cursor-pointer"
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faFolder}
                        style={{ color: "green" }}
                      />
                      <p>Saved Folders</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>
                  <Link
                    to="/notifications"
                    className="flex items-center justify-between cursor-pointer"
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faBell}
                        style={{ color: "green" }}
                      />
                      <p>Notifications</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </Link>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={accountDelete}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>Delete Account</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={redirectToAboutUs}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        style={{ color: "green" }}
                      />
                      <p>About Application</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={redirectToHelp}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        style={{ color: "green" }}
                      />
                      <p>Help</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "green" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <ConnectAccount
          status={status?.onboarding_status}
          isOpen={connectOpen}
          handleAddAccount={handleAddAccount}
          handleUpdateAccount={handleUpdateAccount}
          handleCancelAccount={handleCancelAccount}
        >
          {status?.onboarding_status === "completed" ? (
            <>
              <p>Account Id : {status?.account_id}</p>
              <p>Status : {status?.onboarding_status}</p>
            </>
          ) : (
            <div className="mb-2">
              <Select
                value={selectedCountry}
                onChange={handleCountryChange}
                placeholder="Select Country"
              />
            </div>
          )}
        </ConnectAccount>
        <DeleteAccountModal
          isOpen={openAcountModal}
          handleDeleteCard={handleDeleteAcount}
          handleDeleteCancel={handleDeleteCancel}
        >
          <p className="mb-4 -mt-4">
            Are you sure you want to delete this account?
          </p>
        </DeleteAccountModal>
      </PageContainer>
    </>
  );
};

export default Settings;
